export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_17.1fe60967.jpg";